module.exports = __webpack_public_path__ + "static/clay-logo-0cac8b1f68d2755df473a7619fd07bb9.png";